import React from "react";
import logo from "../assets/logo.jpg";
import workerImage from "../assets/worker-image.jpg";

const PartnershipSection = () => {
  const features = [
    {
      title: "Technical Support",
      description: "Quick response times for troubleshooting and guidance.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-10 h-10"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M13 10V3L4 14h7v7l9-11h-7z"
          />
        </svg>
      ),
      bgColor: "bg-blue-900",
    },
    {
      title: "Reliable Logistics",
      description:
        "Faster delivery with short lead times, reducing project delays.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-10 h-10"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z"
          />
        </svg>
      ),
      bgColor: "bg-orange-500",
    },
    {
      title: "Superior Quality Assurance",
      description:
        "Panels tested with Myanmar's only Sun Simulator and EL Tester for defect-free performance.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-10 h-10"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
          />
        </svg>
      ),
      bgColor: "bg-blue-900",
    },
    {
      title: "Custom Solutions",
      description:
        "Ability to customize panel sizes and specifications to meet your customers' needs.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-10 h-10"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>
      ),
      bgColor: "bg-orange-500",
    },
  ];

  return (
    <section className="bg-white py-20" id="partnership">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
      <img src={logo} alt="Sun Energy Logo" className="h-28 w-auto pb-8" />
        <div className="grid md:grid-cols-2 gap-12">
          {/* Left Column */}
          <div className="flex flex-col space-y-8">
            <div className="flex-1">
              <img
                src={workerImage}
                alt="Worker Operating Machine"
                className="w-full rounded-2xl shadow-lg h-full object-cover"
              />
            </div>
          </div>

          {/* Right Column */}
          <div className="flex flex-col space-y-8">
            <div>
              <h2 className="text-orange-500 font-bold text-2xl mb-4">
                STRATEGIC PARTNERSHIP
              </h2>
              <h3 className="text-4xl md:text-5xl font-bold text-blue-900">
                For Distributors
              </h3>
            </div>

            <div className="space-y-4">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className={`${feature.bgColor} rounded-xl p-6 text-white flex items-start gap-6`}
                >
                  <div className="shrink-0">{feature.icon}</div>
                  <div>
                    <h4 className="text-xl font-bold mb-2">{feature.title}</h4>
                    <p className="text-gray-100 text-xl">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnershipSection;
